
export default function ServiceDetailHead() {
  return (
    <>
    <section className="detailserv-head header-gap">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <span className="sub-tittle">Service</span>
                    <h1 className="heading">millwork</h1>
                    <p>Bespoke millwork that anchors a room - crafted detail, structural finesse, lasting quality. Every panel, frame, and detail is designed to enhance interiors with character, elegance, and endurance.</p>
                </div>
    
            </div>
        </div>

        <img src="/image/millwork-banner.webp" loading="lazy" className="img-responsive" alt="service"/>
    </section>  
    </>
  )
}
